import { format, parse } from "date-fns"
import { CelBreak, CelBreak25, NormalFont } from "./styles"
import { handleFilaAprovadores } from "./Pedido"
import InputGeral from "../InputGeral/Index"

function handleFornecedorSPColumn(item){
    const {PS9_LOJA, A2_NOME, PS9_NATUR, ED_DESCRIC, PS9_TIPO, X5_DESCRI } = item.row.original

    return ( <CelBreak25>
                <strong>{item.value + '/' + PS9_LOJA}</strong> - {A2_NOME.trim()}
                <br/><strong>Tp.Título: </strong>{PS9_TIPO + ' - ' + X5_DESCRI.trim()}
                { PS9_NATUR && PS9_NATUR.trim() && (<><br/><strong>Natureza.: </strong> {PS9_NATUR + "-" + ED_DESCRIC.trim()}</>)  }
            </CelBreak25> )
}

function handleNumeroSPColumn(item, DisparaBootBox, FechaBootBox, navigate){
    const {PS9_ID, EMPRESA, PS9_FILIAL, PS9_NUMTIT, PS9_PRFTIT } = item.row.original
    
    return ( 
        <>
            {<NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("SP", PS9_ID, EMPRESA, PS9_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{PS9_FILIAL}</NormalFont>}
            <br/><NormalFont><strong>Sol. Pgto: {PS9_ID} </strong></NormalFont>
            <br/><NormalFont><strong>Título </strong> - {PS9_NUMTIT}</NormalFont>
            <br/><NormalFont><strong>Pref </strong> - {PS9_PRFTIT}</NormalFont>
        </> 
    )    
}

const handleObservacao = (observacao, DisparaBootBox, FechaBootBox) => {
    const Mensagem = (
        <InputGeral
            tipo="textArea"
            value={observacao}
            disabled={true}
        />
    );

    const buttonsRender = [
        { variant: 'primary', action: FechaBootBox, label: 'Fechar' }
    ];

    DisparaBootBox('Motivo da Crítica', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
}

function handleStatusSPColumn(item, DisparaBootBox, FechaBootBox, navigate){
    const {E2_SALDO, E2_VALOR, PS9_CRITIC } = item.row.original

    if (item.value.trim() === "A"){
        return `Aguard. Aprovação`
    }
    if (item.value.trim() === "R"){
        return `Rejeitado`
    } 
    if (item.value.trim() === "X"){
        if (typeof DisparaBootBox == 'function'){
            return <NormalFont tooltipText="Motivo da Crítica" onClick={(e) => handleObservacao(PS9_CRITIC, DisparaBootBox, FechaBootBox)}>Crítica</NormalFont>
        }else{
            return 'Crítica na Geração do Título'
        }        
    } 
    if (item.value.trim() === "E"){
        return `Título Excluído`
    } 
    if (item.value.trim() === "T"){
        if (E2_SALDO === 0 && E2_VALOR > 0 ){
            return `Título Pago`
        }
        else if (E2_SALDO < E2_VALOR && E2_VALOR > 0 ){
            return `Título Parcial`
        }
        else{
            return `Título Gerado`
        }
    }else{
        return ''
    }
}

export { handleFornecedorSPColumn, handleNumeroSPColumn, handleStatusSPColumn }